import { MessageCircle } from 'lucide-react'
import { whatsAppChatUrl } from '@/lib/whatsapp'
import { STORE_WHATSAPP_NUMBER } from '@/lib/env'

export function WhatsAppFloat() {
  return (
    <a
      href={whatsAppChatUrl(STORE_WHATSAPP_NUMBER)}
      target="_blank"
      rel="noreferrer"
      aria-label="Escríbenos por WhatsApp"
      className="fixed bottom-5 right-5 z-40 flex size-13 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/40 transition-transform hover:scale-105"
    >
      <MessageCircle className="size-6" />
    </a>
  )
}
